import React from "react";
import Masonry from "react-masonry-component";
import { createGlobalStyle } from "styled-components";
import AOS from "aos";
AOS.init();

const GlobalStyles = createGlobalStyle`
    body.hide{
          overflow-y: hidden; /* Hide vertical scrollbar */
          overflow-x: hidden; /* Hide horizontal scrollbar */
        }
`;

const Gallery = function () {
  /* lightbox1 */
  const [lighbx, setlighbx] = React.useState(false);
  const handleBtnClick = (): void => {
    setlighbx(!lighbx);
    var x = document.getElementsByTagName("BODY")[0];
    x.style.overflow = "hidden";
  };
  const handleBtnClickclose = (): void => {
    setlighbx(!lighbx);
    var x = document.getElementsByTagName("BODY")[0];
    x.style.overflow = "auto";
  };

  /* lightbox2 */
  const [lighbx1, setlighbx1] = React.useState(false);
  const handleBtnClick1 = (): void => {
    setlighbx1(!lighbx1);
    var x = document.getElementsByTagName("BODY")[0];
    x.style.overflow = "hidden";
  };
  const handleBtnClickclose1 = (): void => {
    setlighbx1(!lighbx1);
    var x = document.getElementsByTagName("BODY")[0];
    x.style.overflow = "auto";
  };

  /* lightbox2 */
  const [lighbx2, setlighbx2] = React.useState(false);
  const handleBtnClick2 = (): void => {
    setlighbx2(!lighbx2);
    var x = document.getElementsByTagName("BODY")[0];
    x.style.overflow = "hidden";
  };
  const handleBtnClickclose2 = (): void => {
    setlighbx2(!lighbx2);
    var x = document.getElementsByTagName("BODY")[0];
    x.style.overflow = "auto";
  };

  /* lightbox3 */
  const [lighbx3, setlighbx3] = React.useState(false);
  const handleBtnClick3 = (): void => {
    debugger;
    setlighbx3(!lighbx3);
    var x = document.getElementsByTagName("BODY")[0];
    x.style.overflow = "hidden";
  };
  const handleBtnClickclose3 = (): void => {
    setlighbx3(!lighbx3);
    var x = document.getElementsByTagName("BODY")[0];
    x.style.overflow = "auto";
  };
  /* lightbox4 */
  const [lighbx4, setlighbx4] = React.useState(false);
  const handleBtnClick4 = (): void => {
    setlighbx4(!lighbx4);
    var x = document.getElementsByTagName("BODY")[0];
    x.style.overflow = "hidden";
  };

  const handleBtnClickclose4 = (): void => {
    setlighbx4(!lighbx4);
    var x = document.getElementsByTagName("BODY")[0];
    x.style.overflow = "auto";
  };
  const [lighbx5, setlighbx5] = React.useState(false);
  const handleBtnClick5 = (): void => {
    setlighbx5(!lighbx5);
    var x = document.getElementsByTagName("BODY")[0];
    x.style.overflow = "hidden";
  };

  const handleBtnClickclose5 = (): void => {
    setlighbx5(!lighbx5);
    var x = document.getElementsByTagName("BODY")[0];
    x.style.overflow = "auto";
  };
  const [lighbx6, setlighbx6] = React.useState(false);
  const handleBtnClick6 = (): void => {
    setlighbx6(!lighbx6);
    var x = document.getElementsByTagName("BODY")[0];
    x.style.overflow = "hidden";
  };

  const handleBtnClickclose6 = (): void => {
    setlighbx6(!lighbx6);
    var x = document.getElementsByTagName("BODY")[0];
    x.style.overflow = "auto";
  };
  const [lighbx7, setlighbx7] = React.useState(false);
  const handleBtnClick7 = (): void => {
    setlighbx7(!lighbx7);
    var x = document.getElementsByTagName("BODY")[0];
    x.style.overflow = "hidden";
  };

  const handleBtnClickclose7 = (): void => {
    setlighbx7(!lighbx7);
    var x = document.getElementsByTagName("BODY")[0];
    x.style.overflow = "auto";
  };
  const [lighbx8, setlighbx8] = React.useState(false);
  const handleBtnClick8 = (): void => {
    setlighbx8(!lighbx8);
    var x = document.getElementsByTagName("BODY")[0];
    x.style.overflow = "hidden";
  };

  const handleBtnClickclose8 = (): void => {
    setlighbx8(!lighbx8);
    var x = document.getElementsByTagName("BODY")[0];
    x.style.overflow = "auto";
  };

  return (
    <div className="container">
      <GlobalStyles />
      <div className="row">
        <div className="col-md-12 text-center">
          <h2>Portfolio</h2>
          <div className="space-border"></div>
        </div>
      </div>
      <Masonry className={"row my-gallery-class"} elementType={"div"}>
        <div className="col-lg-4 image-element-class de_modal" onClick={handleBtnClick} data-aos="fade-up" data-aos-once="true">
          <div className="card-image-1">
            <div className="d-text">
              <h3>Next Js Prismic</h3>
              <h5 className="d-tag">website</h5>
            </div>
            <img src="./img/gallery/1.png" alt="gallery" />
          </div>
        </div>
        <div className="col-lg-4 image-element-class de_modal" onClick={handleBtnClick1} data-aos="fade-up" data-aos-once="true">
          <div className="card-image-1">
            <div className="d-text">
              <h3>Reactjs Admin Portal</h3>
              <h5 className="d-tag">website</h5>
            </div>
            <img src="./img/gallery/2.png" alt="gallery" />
          </div>
        </div>
        <div className="col-lg-4 image-element-class de_modal" onClick={handleBtnClick2} data-aos="fade-up" data-aos-once="true">
          <div className="card-image-1">
            <div className="d-text">
              <h3>Freelance Business Portfolio Website</h3>
              <h5 className="d-tag">website</h5>
            </div>
            <img src="./img/gallery/3.png" alt="gallery" />
          </div>
        </div>
        <div className="col-lg-4 image-element-class de_modal" style={{ height: 100 }} onClick={handleBtnClick3} data-aos="fade-up" data-aos-once="true">
          <div className="card-image-1">
            <div className="d-text">
              <h3>Github Finder</h3>
              <h5 className="d-tag">React Daisy Ui App</h5>
            </div>
            <img src="./img/gallery/7.png" alt="gallery" />
          </div>
        </div>
      </Masonry>
      <Masonry className={"row my-gallery-class"} elementType={"div"}>
        <div className="col-lg-4 image-element-class de_modal" onClick={handleBtnClick8} data-aos="fade-up" data-aos-once="true">
          <div className="card-image-1">
            <div className="d-text">
              <h3>ToolMarket</h3>
              <h5 className="d-tag">Nextjs with Sanity</h5>
            </div>
            <img src="./img/gallery/ToolMarket.png" alt="gallery" />
          </div>
        </div>
        <div className="col-lg-4 image-element-class de_modal" onClick={handleBtnClick5} data-aos="fade-up" data-aos-once="true">
          <div className="card-image-1">
            <div className="d-text">
              <h3>Reports Management System</h3>
              <h5 className="d-tag">React with firebase</h5>
            </div>
            <img src="./img/gallery/oto.png" alt="gallery" />
          </div>
        </div>
        <div className="col-lg-4 image-element-class de_modal" onClick={handleBtnClick6} data-aos="fade-up" data-aos-once="true">
          <div className="card-image-1">
            <div className="d-text">
              <h3>Talent Hub</h3>
              <h5 className="d-tag">Nextjs with Sanity</h5>
            </div>
            <img src="./img/gallery/TalentHub.png" alt="gallery" />
          </div>
        </div>
        <div className="col-lg-4 image-element-class de_modal" onClick={handleBtnClick7} data-aos="fade-up" data-aos-once="true">
          <div className="card-image-1">
            <div className="d-text">
              <h3>DownLights</h3>
              <h5 className="d-tag">Nextjs with MicroFeed</h5>
            </div>
            <img src="./img/gallery/Downlight.jpg" alt="gallery" />
          </div>
        </div>
        <div className="col-lg-4 image-element-class de_modal" onClick={handleBtnClick4} data-aos="fade-up" data-aos-once="true">
          <div className="card-image-1">
            <div className="d-text">
              <h3>Jamstack Directus</h3>
              <h5 className="d-tag">Nextjs with Directus</h5>
            </div>
            <img src="./img/gallery/Mulhaq.png" alt="gallery" />
          </div>
        </div>
      </Masonry>

      {/* lightbox1 */}
      {lighbx && (
        <div className="LightboxGal">
          <div className="closeGal">
            <button className="button-close" onClick={handleBtnClickclose}></button>
          </div>
          <div className="v-center w-100">
            <div className="mainLightbox container">
              <div className="row g-5">
                <div className="col-lg-8">
                  <img src="./img/gallery/1.png" alt="" className="img-fluid" />
                </div>

                <div className="col-lg-4 de_project-info">
                  <h3>Next Js Prismic</h3>
                  <p>As a developer, I take pride in crafting a professional online presence for my client's company. Combining the power of Bootstrap for responsive design, Next.js for lightning-fast performance, and Prismic for seamless content management, this website is a dynamic gateway to showcase my client's business. Explore the company's offerings, from services to case studies, and gain insights from the engaging blog section. My client's website is a testament to their commitment to excellence and their partnership with a developer who values cutting-edge technology. It's more than just a website; it's a digital embodiment of their brand's strength and expertise.</p>

                  <div className="de_project-details">
                    <div className="d-field">
                      <i className="fa fa-external-link"></i>Preview:{" "}
                      <span>
                        <a href="https://engineer-guild1.vercel.app/" target="_blank" rel="noreferrer">
                          Engineer Guild
                        </a>
                      </span>
                    </div>
                  </div>
                  <div className="spacer-30"></div>
                  <blockquote>
                    "Abdul Sami has delivered the best business website, blending creativity and technology, resulting in an impressive online presence that resonates with our brand and drives success.."
                    <span>Dr Rizwan</span>
                  </blockquote>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* lightbox2 */}
      {lighbx1 && (
        <div className="LightboxGal">
          <div className="closeGal">
            <button className="button-close" onClick={handleBtnClickclose1}></button>
          </div>
          <div className="v-center w-100">
            <div className="mainLightbox container">
              <div className="row g-5">
                <div className="col-lg-8">
                  <div className="row g-4">
                    <div className="col-lg-12">
                      <img src="./img/gallery/2.png" alt="" className="img-fluid" />
                    </div>
                  </div>
                </div>

                <div className="col-lg-4 de_project-info">
                  <h3>Reactjs Report Management System</h3>
                  <p>The Crane Report Management Software, built with React, is a powerful tool for businesses to streamline and enhance their reporting processes. This innovative software simplifies the creation, storage, and analysis of critical data, providing real-time insights and improving decision-making. With its user-friendly interface and robust capabilities, it empowers organizations to efficiently manage and optimize their reporting tasks, ultimately contributing to improved operational efficiency and informed decision-making.</p>

                  {/* <div className="de_project-details">
										<div className="d-field">
											<i className="fa fa-external-link"></i>Preview:{" "}
											<span>
												<a
													href="https://engineer-guild1.vercel.app/"
													target="_blank"
													rel="noreferrer"
												>
													Engineer Guild
												</a>
											</span>
										</div>
									</div> */}
                  <div className="spacer-30"></div>
                  <blockquote>
                    "The Crane Report Management Software, has significantly boosted our company's efficiency, revolutionizing how we handle and analyze critical data."
                    <span>Mr Azeem</span>
                  </blockquote>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* lightboxvideo */}
      {lighbx2 && (
        <div className="LightboxGal">
          <div className="closeGal">
            <button className="button-close" onClick={handleBtnClickclose2}></button>
          </div>
          <div className="v-center w-100">
            <div className="mainLightbox container">
              <div className="row g-5">
                <div className="col-lg-8">
                  <img src="./img/gallery/3.png" alt="" className="img-fluid" />
                </div>

                <div className="col-lg-4 de_project-info">
                  <h3>Freelance Business Portfolio Website</h3>
                  <p>My freelance business portfolio website is the window to my professional world, showcasing a curated collection of my best work. With an elegant design and user-friendly navigation, it's a testament to my skills, creativity, and commitment to delivering top-notch solutions.</p>

                  <div className="de_project-details">
                    <div className="d-field">
                      <i className="fa fa-external-link"></i>Preview:{" "}
                      <span>
                        <a href="https://iyouwork.com/" target="_blank" rel="noreferrer">
                          iyouwork.com
                        </a>
                      </span>
                    </div>
                  </div>
                  <div className="spacer-30"></div>
                  <blockquote>
                    "I had the pleasure of working with Abdul Sami on a critical project. His attention to detail, technical skills, and creative approach made a substantial difference in our online visibility"
                    <span>Mark Abraham</span>
                  </blockquote>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* lightboxvideo */}
      {lighbx3 && (
        <div className="LightboxGal">
          <div className="closeGal">
            <button className="button-close" onClick={handleBtnClickclose3}></button>
          </div>
          <div className="v-center w-100">
            <div className="mainLightbox container">
              <div className="row g-5">
                <div className="col-lg-8">
                  <img src="./img/gallery/7.png" alt="" className="img-fluid" />
                </div>

                <div className="col-lg-4 de_project-info">
                  <h3>Reactjs Github Finder </h3>
                  <p>Developed this project using React where you can search any github user and view their profile. Developed using modern technologies using React Js and tailwind css. It feels cool working on such wonderful app and working with apis Search any Id with just one search ! GitAPIs is a set of APIs provided by GitHub that allow developers to programmatically access and interact with various features of the GitHub platform, including repositories, issues, pull requests, and more.</p>

                  <div className="spacer-30"></div>
                  <blockquote>Side Project just for fun</blockquote>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* lightboxvideo */}
      {lighbx4 && (
        <div className="LightboxGal">
          <div className="closeGal">
            <button className="button-close" onClick={handleBtnClickclose4}></button>
          </div>
          <div className="v-center w-100">
            <div className="mainLightbox container">
              <div className="row g-5">
                <div className="col-lg-8">
                  <img src="./img/gallery/Mulhaq.png" alt="" className="img-fluid" />
                </div>

                <div className="col-lg-4 de_project-info">
                  <h3>Directus Headless Integration Nextjs </h3>
                  <p>Directus with Next.js Integration: Seamlessly integrate Directus, a headless CMS, with Next.js, a React-based framework for web applications. This powerful combination allows developers to leverage the content management capabilities of Directus while benefiting from the flexibility and performance optimization of Next.js, enabling the creation of dynamic and efficient web applications with a streamlined development workflow.</p>

                  <div className="spacer-30"></div>
                  <blockquote>
                    "A good person to work with, able to solve problems on the. Next project it is!"
                    <span>Saya Luqman</span>
                  </blockquote>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {lighbx5 && (
        <div className="LightboxGal">
          <div className="closeGal">
            <button className="button-close" onClick={handleBtnClickclose5}></button>
          </div>
          <div className="v-center w-100">
            <div className="mainLightbox container">
              <div className="row g-5">
                <div className="col-lg-8">
                  <img src="./img/gallery/oto.png" alt="" className="img-fluid" />
                </div>

                <div className="col-lg-4 de_project-info">
                  <h3>Reporting Management System </h3>
                  <p>Building a dashboard using React and Firebase allows for the creation of dynamic, real-time data visualization and management interfaces. Leveraging React's component-based architecture enables the development of a modular and responsive dashboard UI, while Firebase services such as Firestore can handle real-time data synchronization, storage, and retrieval. Firebase Authentication ensures secure user access, allowing developers to implement personalized dashboards with role-based permissions. The combination of React and Firebase offers a streamlined development process, making it an ideal choice for crafting efficient and visually appealing dashboards with features like live updates, user authentication, and seamless integration with a cloud-based backend.</p>

                  <div className="spacer-30"></div>
                  <blockquote>
                    "Abdul's professionalism and expertise were inspiring. The custom software not only exceeded expectations but also transformed my business efficiency. Highly recommend!"
                    <span>CEO, Otto Manufacturing</span>
                  </blockquote>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {lighbx6 && (
        <div className="LightboxGal">
          <div className="closeGal">
            <button className="button-close" onClick={handleBtnClickclose6}></button>
          </div>
          <div className="v-center w-100">
            <div className="mainLightbox container">
              <div className="row g-5">
                <div className="col-lg-8">
                  <img src="./img/gallery/TalentHub.png" alt="" className="img-fluid" />
                </div>

                <div className="col-lg-4 de_project-info">
                  <h3>Talent Hub</h3>
                  <p>This project aims to develop a complex website utilizing the architectural advantages of Jamstack and the content management capabilities of Sanity. Key Technologies: Jamstack: Static site generation for scalability and performance. Sanity: Headless CMS for flexible and structured content management. Project Scope: Develop a robust data model within Sanity to accommodate the website's complex content requirements. Design and implement efficient APIs to deliver the necessary data to the frontend framework. Build a dynamic and interactive frontend using a preferred framework (e.g., React, Vue) to handle complex functionalities and workflows. Benefits: Fast loading times and high traffic handling. Flexibility in frontend development choices. Structured content management for complex data. Offline editing capabilities for content creators. Considerations: Project complexity requires careful planning and expertise in data modeling, API design, and frontend development. Choosing the right approach depends on project requirements and team skillset. Overall, this project leverages the strengths of Jamstack and Sanity to deliver a performant, scalable, and content-rich website for a complex use case.</p>

                  <div className="spacer-30"></div>
                  <blockquote>
                    "He really tries to understand the requirements by asking many great questions, doing thorough researching and offering different suggestions and versions to choose from. I can't recommend him enough, he's that good! Thanks"
                    <span>Muhammad Ali</span>
                  </blockquote>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {lighbx7 && (
        <div className="LightboxGal">
          <div className="closeGal">
            <button className="button-close" onClick={handleBtnClickclose7}></button>
          </div>
          <div className="v-center w-100">
            <div className="mainLightbox container">
              <div className="row g-5">
                <div className="col-lg-8">
                  <img src="./img/gallery/Downlight.jpg" alt="" className="img-fluid" />
                </div>

                <div className="col-lg-4 de_project-info">
                  <h3>DownLights </h3>
                  <p>This project focuses on building a lightning-fast website utilizing the power of Jamstack architecture and Next.js, along with the engaging format of microfeeds. Tech Stack: Jamstack: Leverages pre-rendered static content for exceptional speed and scalability. Next.js: A React framework offering server-side rendering (SSR) and static site generation (SSG) capabilities for optimal performance. Microfeeds: A content format showcasing concise, bite-sized updates, ideal for frequent content delivery. Project Goals: Achieve blazing-fast loading times: By combining Jamstack and Next.js, the website will deliver content instantly, enhancing user experience. Implement microfeeds: Integrate microfeeds to display content updates in a captivating and easy-to-consume format, fostering user engagement. Ensure content freshness: Leverage features like incremental static regeneration (ISR) in Next.js to keep content automatically updated, maintaining information accuracy. Benefits: Unmatched speed and performance: Users experience near-instantaneous page loads, leading to increased satisfaction and lower bounce rates. Engaging content delivery: Microfeeds provide an attractive and dynamic way to present information, keeping users informed and interested. Scalability and cost-effectiveness: Jamstack architecture ensures efficient handling of high traffic volumes while minimizing server costs. Considerations: Project success hinges on expertise in Next.js functionalities like SSR, SSG, and ISR for optimal performance. Content strategy needs careful planning to cater to the microfeed format, focusing on concise and valuable updates. In conclusion, this project merges the strengths of Jamstack, Next.js, and microfeeds to create a high-performance website that delivers content at lightning speed, fostering user engagement and satisfaction.</p>

                  <div className="spacer-30"></div>
                  <blockquote>
                    "Abdul did yet another amazing job! He's got such excellent skills for both design and development. He likes to get a deep understanding of the requirements and well and truely above and beyond to make sure he's successfully done his job well."
                    <span>Cameron Matthews</span>
                  </blockquote>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {lighbx8 && (
        <div className="LightboxGal">
          <div className="closeGal">
            <button className="button-close" onClick={handleBtnClickclose8}></button>
          </div>
          <div className="v-center w-100">
            <div className="mainLightbox container">
              <div className="row g-5">
                <div className="col-lg-8">
                  <img src="./img/gallery/ToolMarket.png" alt="" className="img-fluid" />
                </div>

                <div className="col-lg-4 de_project-info">
                  <h3>ToolMarket</h3>
                  <p>This project builds a robust e-commerce marketplace using the cutting-edge combination of Next.js and Sanity. Key Features: Next.js: Provides a lightning-fast and scalable foundation for the frontend, handling dynamic features and user interactions. Sanity: Offers a flexible and user-friendly headless CMS for managing product information, images, and descriptions. Project Capabilities: Product listings and details: Showcase a wide range of products with rich information and engaging visuals. Search and filtering: Allow users to easily find desired products using keywords and category filters. Secure shopping cart and checkout: Facilitate seamless transactions with secure payment gateways. User accounts and management: Enable user accounts for personalized shopping experiences and order history. Benefits: Scalability and performance: Next.js ensures a smooth user experience even with high traffic volumes. Content flexibility: Sanity empowers easy content management and updates through a user-friendly interface. Customization: The combination allows for tailored functionalities specific to market needs. Ideal For: This project is well-suited for entrepreneurs or businesses seeking to: Launch a modern and efficient marketplace platform. Offer a user-friendly and intuitive shopping experience. Manage product data efficiently with a flexible CMS. Overall, this project leverages the strengths of Next.js and Sanity to create a scalable and user-centric e-commerce marketplace that simplifies product buying and selling.</p>

                  <div className="spacer-30"></div>
                  <blockquote>
                    "Abdul is a very responsible developer and very prompt to reply your questions."
                    <span>Henry, Clearify Expert</span>
                  </blockquote>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;
